import React, { useState, useEffect } from 'react';

import { Typography, Box, Grid, Card, Button, Divider,List, ListItem, ListItemText, CardContent, useMediaQuery, useTheme } from '@mui/material';
import * as C from "../componentsM/index";
import mainPicture from "../assets/picture6.jpg";
import event from "../assets/bg-events.jpg";
import eventFrame1 from "../assets/DSC_0229.jpg";
import eventFrame2 from "../assets/c.jpg";
import eventFrame3 from "../assets/w.jpg";
import eventFrame4 from "../assets/IMG-20211018-WA0041.jpg";
import careerImage from "../assets/career_image.jpg";
import bg1 from "../assets/maincrousel/main1.JPG";
import bg2 from "../assets/maincrousel/main2.JPG";
import bg3 from "../assets/maincrousel/main3.JPG";
import bg4 from "../assets/maincrousel/main4.JPG";
import bg5 from "../assets/maincrousel/main5.JPG";
import { fetchEvents ,fetchTestimonials} from '../components/apifa';
import Timeline from './Timeline';
const backgroundImages = [bg1, bg2, bg3, bg4, bg5];

const Home = () => {

  const theme = useTheme();
  const [events, setEvents] = useState([]);
  // const isMobile = useMediaQuery('(max-width:600px)');
  const listItems = [
    "Choice of subject based on interest, career or profession?",
    "Choice of college or university?",
    "Choice of country or location?",
    "Academic achievements?",
    "Affordability?",
    "Travel restrictions and considerations.",
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Mobile screen detection
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md')); // Tablet detection

  useEffect(() => {
    
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % backgroundImages.length);
    }, 5000); 

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const getEvents = async () => {
      try {
        const data = await fetchEvents();
        setEvents(data);
      } catch (error) {
        console.error('Error:', error);
      }
    };

    getEvents();
  }, []);

  return (
    <>


      
      <div className="relative">


        {/* <Box
        sx={{paddingTop: '5px',position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden'}}
        > */}
      <Box
  sx={{
    flex: 1,
    position: 'relative',
    height: '70vh',
    backgroundImage: `url(${backgroundImages[currentImageIndex]})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    transition: 'background-image 2s ease-in-out',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  {/* Card Overlay */}
  <Box
    sx={{
      textAlign: 'center',
      color: 'white',
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // Optional for better text visibility
      padding: '1rem',
      borderRadius: '8px',
    }}
  >
    {/* Heading */}
    <h1
      style={{
        fontSize: 'clamp(24px, 5vw, 56px)',
        fontWeight: 'bold',
        textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
        marginBottom: '1rem',
      }}
    >
      First IB World <br /> School in Pakistan
    </h1>

    {/* Subheading */}
    <p
      style={{
        fontSize: 'clamp(12px, 2vw, 25px)',
        textShadow: '1px 1px 2px rgba(0,0,0,0.7)',
      }}
    >
      "Education is the silent force"
    </p>
  </Box>
{/* {/* </Box> */}
</Box> 


      </div>
      <div className="flex flex-col items-center pb-[50px]">
        <div className="max-w-[1140px] px-[15px] text-center">
          <h2 className=" word-space text-[#263d5f] sm:text-[42px] font-bold text-xl sm:font-normal uppercase sm:leading-[44px] text-center mt-[50px]">
            The International School Educational Technology
          </h2>
          <p className="sm:text-[20px] text-[#444] text-center w-full max-w-[810px] mx-auto ">
            Technology is an integral part of our community.  Our campuses are installed with fibre-optics internet service and multimedia systems in every room. The school has a one laptop per child policy, for all students from age 10 years onwards.
          </p>
          <a href="/educational-technology" className="bg-[#f7c612] min-w-[223px] inline-block text-center text-[20px] text-[#441] font-normal p-[10px] mt-[30px]">Learn More</a>
        </div>
      </div>
      <Timeline/>
      <Box
      sx={{
        backgroundImage: `url(${event})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        py: 5,
      }}
    >
      <Box sx={{ maxWidth: '1140px', mx: 'auto', px: 2 }}>
        <Typography
          variant="h4"
          sx={{
            alignSelf: 'center',
            color: '#263d5f',
            fontFamily: 'Open Sans',
            fontWeight: 'normal',
            textTransform: 'uppercase',
            mb: 4,
          }}
        >
          Upcoming Event
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: 4,
          }}
        >
          {/* Event List */}
          <Box
            sx={{
              width: isMobile ? '100%' : '40%',
              maxHeight: '40vh',
              overflowY: 'auto',
              borderRadius: 2,
              p: 2,
              backgroundColor: 'rgba(0, 0, 0, 0.2)',
              '&::-webkit-scrollbar': {
                display: 'none',
              },
              '-ms-overflow-style': 'none', // For Internet Explorer and Edge
              'scrollbar-width': 'none',   // For Firefox
            }}
          >
            <List>
              {events.map((event) => (
                <React.Fragment key={event.id}>
                  <ListItem>
                    <Box sx={{ textAlign: 'center', mr: 2 }}>
                      <Typography variant="h5" sx={{ color: 'white' }}>
                        {new Date(event.date).getDate()}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{ color: '#263d5f', fontWeight: 'bold' }}
                      >
                        {new Date(event.date).toLocaleString('en-US', {
                          month: 'short',
                        })}
                      </Typography>
                    </Box>
                    <ListItemText
                      primary={event.name}
                      secondary={`${event.location}`}
                      primaryTypographyProps={{
                        sx: { color: '#263d5f', fontWeight: 'bold', fontFamily: 'Montserrat' },
                      }}
                      secondaryTypographyProps={{
                        sx: { color: 'white', textTransform: 'uppercase', fontFamily: 'Open Sans' },
                      }}
                    />
                  </ListItem>
                  <Divider sx={{ borderColor: '#fff' }} />
                </React.Fragment>
              ))}
            </List>
          </Box>

          {/* Image Section */}
          {!isMobile && (
           <div className="w-[50%]    truncate border-solid border-[5px] border-white bg-black cursor-pointer  ">
           <div className="event-frame-wrap">
             <img src={eventFrame2} alt="" className="max-w-full h-auto" />
             <img src={eventFrame4} alt="" className="max-w-full h-auto" />
             <img src={eventFrame1} alt="" className="max-w-full h-auto" />
             <img src={eventFrame3} alt="" className="max-w-full h-auto" />
           </div>
         </div>
          )}
        </Box>
      </Box>
    </Box>

    <div className="py-[50px]">
  <div className="max-w-[1140px] px-3 md:px-[50px] flex flex-col md:flex-row items-center md:mx-auto gap-6">
    <div className="md:w-[70%] text-center md:text-left">
      <h2 className="uppercase md:text-[35px] text-[#263d5f] font-bold mb-[10px]" style={{ fontFamily: "Montserrat" }}>
        MEET THE ADMISSIONS TEAM IN TIS
      </h2>
      <p className="pr-[25px] text-[#444] md:text-[21px]">
        We accept admission applications throughout the year for our myOrange, Middle, and High School programmes.
      </p>
    </div>
    <a
      href="/MeetTheAdmissionTeam"
      className="bg-[#f7c612] md:px-[70px] md:h-[70px] md:min-w-[223px] inline-block text-center md:text-[20px] text-[#333] font-normal px-2 md:p-[10px] rounded leading-[50px]"
      style={{ fontFamily: 'RoundedElegance',fontSize: 'calc(20px)' ,}}
    >
      Admission Team
    </a>
  </div>
</div>

<C.Events />



      <div className="flex flex-wrap overflow-hidden  h-fit md:h-[550px]">




        <figure className="w-full md:w-1/2 h-full">
          <img className="w-full h-full object-cover" src={careerImage} alt="" />
        </figure>




        <div className="w-full md:w-1/2 md:min-h-[100%] h-fit bg-[#f7c612] px-[50px] py-[35px] career relative">
          <i className="custom-triangle p-20 md:block hidden bg-[#f7c612] absolute"></i>
          <h2 className="uppercase text-[#263d5f]  mb-[10px] text-[30px]">Career & University Counselling</h2>
          <div className="text-[#444] text-[17px] pr-[10px] font-semibold">
            One of the most important decisions students and parents will have to make is of thinking about applying for higher education?
            <ul className="list-disc list-inside my-2">
              {listItems.map((item, index) => (
                <li key={index} className="text-sm">{item}</li>
              ))}
            </ul>
            <button className="readmore" onClick={() => window.location.href = '/CareerAndUniCounseling'}>Read More</button>

            
          </div>
        </div>




      </div>


      
      <C.Testimonial />


     
      <C.Map />

    </>
  );
}

export default Home;